import React from "react";
import { Box } from "../../UI/Box";

export const SnapchatIcon = () => (
  <Box component="img" width={21} height={21} src="/static/images/snapchat-icon.png" alt="snapchat" />
);
